export default "__VITE_ASSET__BNNCO105__"